import * as React from 'react';
import { Table } from '../../CommonUI';
import Button from '../../CommonUI/Control/Button';
import { StyleSheet, css } from 'aphrodite';
import { Text } from 'ilenia';
import { Common } from './../../Assets/styles/common';

interface FailedOrdersTableProps {
    syncedCount: number;
    failedCount: number;
    source: string;
    onSync: () => void;
    tierName: string;
}

export class FailedOrdersTable extends React.Component<FailedOrdersTableProps> {
    public render() {
        const { syncedCount, failedCount, onSync, source, tierName } = this.props;
        const inputId = 'past-orders-import';
        const data = [
            {
                Status: (
                    <button className={css(styles.button, failedCount > 0 && styles.attention, failedCount === 0 && styles.success)}>
                        <Text id={failedCount > 0 ? 'pastOrders.attention' : 'pastOrders.success'} />
                    </button>
                ),
                OrdersSynced: syncedCount,
                OrdersFailed: failedCount,
                Actions: (
                    <Button
                        secondaryButton={true}
                        onClick={onSync}
                        track={{
                            placement: 'In past orders table',
                            action: 'Resync past orders clicked',
                            name: 'resync-past-orders-button',
                            source,
                            tierName,
                        }}
                        mt={0}
                        pl={0}
                        pr={0}
                        disabled={failedCount === 0}
                    >
                        <Text id={'pastOrders.sync'} />
                    </Button>
                )
            }
        ];

        const getTrGroupProps = () => {
            return {
                style: {
                    minHeight: '70px',
                }
            };
        };

        return (
            <Table
                id={inputId}
                className={css(styles.table)}
                label="pastOrders.pastOrdersSummary"
                cols={[
                    {label: 'pastOrders.status', accessor: 'Status'},
                    {label: 'pastOrders.ordersSynced', accessor: 'OrdersSynced'},
                    {label: 'pastOrders.ordersFailed', accessor: 'OrdersFailed'},
                    {label: 'pastOrders.actions', accessor: 'Actions'}
                ]}
                data={data}
                showPagination={false}
                defaultPageSize={data!.length}
                getTrGroupProps={getTrGroupProps}
            />
        );
    }
}

const styles = StyleSheet.create({
    table: {
        height: '114px'
    },
    button: {
        margin: 'auto'
    },
    attention: {
        width: '74px',
        height: '20px',
        borderRadius: '3px',
        backgroundColor: '#f9c84d',
        fontFamily: 'Lato',
        fontSize: '10px',
        fontWeight: 'normal',
        lineHeight: '1.2',
        color: '#ffffff',
        outline: 'none',
        border: 'none'
    },
    success: {
        width: '74px',
        height: '20px',
        borderRadius: '3px',
        backgroundColor: Common.Color.greenColor,
        fontFamily: 'Lato',
        fontSize: '10px',
        fontWeight: 'normal',
        lineHeight: '1.2',
        color: Common.Color.lightTextColor,
        outline: 'none',
        border: 'none'
    },
});
